import { Static, Type } from '@sinclair/typebox';

export const SocialHandleSchema = Type.Object({
  url: Type.Optional(Type.String({ description: 'The url of the user profile' })),
  name: Type.Optional(Type.String({ description: 'The name of the user on the social media' })),
});

export type SocialHandle = Static<typeof SocialHandleSchema>;

export const SOCIAL_HANDLE_KEYS = [
  'linkedin',
  'instagram',
  'github',
  'facebook',
  'x',
  'threads',
  'tiktok',
  'wechat',
  'gtalk',
  'qq',
  'skype',
  'icq',
  'xmpp',
  'sip',
  'yahoo',
  'aim',
  'jabber',
  'msn',
  'netmeeting',
  'googletalk',
] as const;

export type SocialHandleKey = (typeof SOCIAL_HANDLE_KEYS)[number];

export function isSocialHandleKey(key: string): key is SocialHandleKey {
  return SOCIAL_HANDLE_KEYS.some((k) => k === key);
}

export const SocialHandlesSchema = Type.Partial(
  Type.Object(
    {
      linkedin: SocialHandleSchema,
      instagram: SocialHandleSchema,
      github: SocialHandleSchema,
      facebook: SocialHandleSchema,
      x: SocialHandleSchema,
      threads: SocialHandleSchema,
      tiktok: SocialHandleSchema,
      wechat: SocialHandleSchema,
      gtalk: SocialHandleSchema,
      qq: SocialHandleSchema,
      skype: SocialHandleSchema,
      icq: SocialHandleSchema,
      xmpp: SocialHandleSchema,
      sip: SocialHandleSchema,
      yahoo: SocialHandleSchema,
      aim: SocialHandleSchema,
      jabber: SocialHandleSchema,
      msn: SocialHandleSchema,
      netmeeting: SocialHandleSchema,
      googletalk: SocialHandleSchema,
    },
    { description: 'List of user social handles.' },
  ),
);

export type SocialHandles = Static<typeof SocialHandlesSchema>;
